import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../services/HttpManager";
import { telefonoBonito } from "../../../utils/telefonoBonito";
import { errorTexto, RESULTADOS_LLAMADA } from "./salesHelpers";

interface Props {
	campusId: number;
	prospectId: number;
	nombre: string;
	telefono: string;
	origen: "manual" | "marcador";
	onClose: () => void;
	onGuardado: (resultado: string) => void;
}

const MAS_TARDE: { min: number; label: string }[] = [{ min: 60, label: "en 1 h" }, { min: 180, label: "en 3 h" }, { min: 60 * 20, label: "mañana" }];

/**
 * Llamar y registrar cómo terminó. El teléfono dentro de WAPP (Telnyx) marca, graba y mide la duración solo; mientras
 * la cuenta no esté activa se marca desde el teléfono de siempre y aquí se deja el resultado (la bitácora no se pierde).
 */
const Llamada: React.FC<Props> = ({ campusId, prospectId, nombre, telefono, origen, onClose, onGuardado }) => {
	const [resultado, setResultado] = useState<string>("");
	const [nota, setNota] = useState<string>("");
	const [tarde, setTarde] = useState<number>(0);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const [copiado, setCopiado] = useState<boolean>(false);

	const guardar = async () => {
		setBusy(true); setError(null);
		try {
			await HttpManager.getInstance().prospectsService.call(campusId, prospectId, { result: resultado, note: nota.trim() || undefined, source: origen, laterMinutes: tarde || undefined });
			onGuardado(resultado);
		} catch (e) { setError(errorTexto(e)); }
		finally { setBusy(false); }
	};

	const copiar = () => {
		try { navigator.clipboard.writeText(telefono.replace(/^\+/, "")); setCopiado(true); setTimeout(() => setCopiado(false), 1500); } catch (e) { /* sin portapapeles */ }
	};

	return (
		<Modal show onHide={onClose} className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Llamar a {nombre}</Modal.Title></Modal.Header>
			<Modal.Body style={{ display: "flex", flexDirection: "column", gap: 14 }}>
				<div className="ll-numero">
					<span>{telefonoBonito(telefono)}</span>
					<button className="btn-wa" onClick={copiar}>{copiado ? "Copiado" : "Copiar"}</button>
				</div>
				<div className="aviso">El teléfono de WAPP se enciende al activar la cuenta de Telnyx. Mientras, marca como siempre y deja aquí cómo terminó.</div>
				<div>
					<label>Cómo terminó</label>
					<div className="ll-resultados">
						{RESULTADOS_LLAMADA.map((r) => (
							<button key={r.key} className={"btn-wa" + (resultado === r.key ? " pri" : "")} onClick={() => setResultado(r.key)}>{r.label}</button>
						))}
					</div>
				</div>
				<div><label htmlFor="ll-nota">Nota</label><textarea id="ll-nota" rows={3} value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Qué dijo, qué quedó" /></div>
				{resultado && resultado !== "contesto" && resultado !== "equivocado" ? (
					<div>
						<label>Volver a intentar</label>
						<div className="ll-resultados">
							{MAS_TARDE.map((m) => <button key={m.min} className={"btn-wa" + (tarde === m.min ? " pri" : "")} onClick={() => setTarde(tarde === m.min ? 0 : m.min)}>{m.label}</button>)}
						</div>
					</div>
				) : null}
				{error ? <div className="aviso error">{error}</div> : null}
			</Modal.Body>
			<Modal.Footer>
				<button className="btn-wa" onClick={onClose}>Cancelar</button>
				<button className="btn-wa pri" disabled={!resultado || busy} onClick={guardar}>{origen === "marcador" ? "Guardar y siguiente" : "Guardar"}</button>
			</Modal.Footer>
		</Modal>
	);
};

export default Llamada;
